import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { ConfigPdvDeliveryRequest, ConfiguracaoModel } from 'src/app/shared/models/configuracao.model';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class SistemaService {
    constructor(
        private http: HttpClient,
        private authService: AuthenticationService
    ) { }

    private get base() {
        return `${this.authService.baseUrl}/sistema`;
    }

    getConfiguracoes() {
        return this.http.get<ApiResponse<ConfiguracaoModel>>(`${this.base}/configuracoes`);
    }

    public setConfigDelivery(request: ConfigPdvDeliveryRequest) {
        return this.http.post<ApiResponse<ConfigPdvDeliveryRequest>>(`${this.base}/ConfigsDelivery`, request);
    }
}
